import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getEmployment } from '../../../../../../global/ducks/benadmin-api';
import { TcsmStates } from '../../../../../../root/tcsm-model';
import { setNewHireEnrollmentMemeberEmployment } from '../../slice/new-hire-enrollment-slices';

export function useMemberEmployment() {
    const dispatch = useDispatch();
    
    const memberEmploymentLoaded = useSelector<TcsmStates, boolean>(state => state?.newHireEnrollmentState?.memberEmploymentLoaded);

    const memberCurrentEmploymentId = useSelector<TcsmStates, number>(state => state?.newHireEnrollmentState?.memberCurrentEmploymentId);
    const memberCurrentEmploymentIdLoaded = useSelector<TcsmStates, boolean>(state => state?.newHireEnrollmentState?.memberCurrentEmploymentIdLoaded);
    const personGuid = useSelector<TcsmStates, string>(state => state?.authenticatedState?.clientGuid);    

    useEffect(() => {
        if (memberCurrentEmploymentIdLoaded && memberCurrentEmploymentId  && !memberEmploymentLoaded && personGuid) {
            dispatch(getEmployment(
                personGuid,
                memberCurrentEmploymentId,
                (response)=>{
                    dispatch(setNewHireEnrollmentMemeberEmployment(response?.data));
                }));            
        }
    }, [memberCurrentEmploymentId, personGuid]);

    return memberCurrentEmploymentIdLoaded && memberEmploymentLoaded;
}